import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ScannerIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.8 10.7L4.2 5L3.5 6.9L17.6 12L5 12C3.9 12 3 12.9 3 14L3 18C3 19.1 3.9 20 5 20L19 20C20.1 20 21 19.1 21 18L21 12.5C21 11.7 20.5 10.9 19.8 10.7ZM19 18L5 18L5 14L19 14L19 18ZM6 15L8 15L8 17L6 17L6 15ZM10 15L18 15L18 17L10 17L10 15Z"
      fill="currentColor"
    />
  </svg>
);

ScannerIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ScannerIcon);
